import { render } from "./EaseIn.vue?vue&type=template&id=35e20e94&scoped=true"
import script from "./EaseIn.vue?vue&type=script&lang=js"
export * from "./EaseIn.vue?vue&type=script&lang=js"

import "./EaseIn.vue?vue&type=style&index=0&id=35e20e94&scoped=true&lang=css"

import exportComponent from "/Users/ts/Desktop/works/lancers_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e20e94"]])

export default __exports__